import { bodyPrimary, headingPrimary } from "@/constants";
import { onDarkBase } from "@biom3/design-tokens";

export function pxToRem(value: number) {
  return `${value / 16}rem`;
}

export const primaryFont = bodyPrimary.style.fontFamily;
export const secondaryFont = headingPrimary.style.fontFamily;

export const typography = {
  fontFamily: primaryFont,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  h1: {
    fontFamily: secondaryFont,
    fontWeight: 700,
    lineHeight: 1.25,
    fontSize: pxToRem(40),
  },
  h2: {
    fontFamily: secondaryFont,
    fontWeight: 700,
    lineHeight: 1.25,
    fontSize: pxToRem(32),
  },
  h3: {
    fontFamily: secondaryFont,
    fontWeight: 600,
    lineHeight: 1.25,
    fontSize: pxToRem(24),
  },
  h4: {
    fontFamily: secondaryFont,
    fontWeight: 600,
    lineHeight: 1.25,
    fontSize: pxToRem(20),
  },
  h5: {
    fontFamily: secondaryFont,
    fontWeight: 600,
    lineHeight: 1.25,
    fontSize: pxToRem(18),
  },
  h6: {
    fontFamily: secondaryFont,
    fontWeight: 600,
    lineHeight: 1.25,
    fontSize: pxToRem(16),
  },
  subtitle1: {
    fontFamily: secondaryFont,
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(16),
  },
  subtitle2: {
    fontFamily: secondaryFont,
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(14),
  },
  body1: {
    lineHeight: 1.5,
    fontSize: pxToRem(16),
  },
  body2: {
    lineHeight: 1.5,
    fontSize: pxToRem(14),
  },
  button: {
    fontFamily: secondaryFont,
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(14),
    textTransform: "none" as const,
  },
  caption: {
    fontSize: pxToRem(10),
    textTransform: "uppercase" as const,
    letterSpacing: "2px",
  },
  overline: {
    fontFamily: secondaryFont,
    fontWeight: 600,
    fontSize: pxToRem(12),
    lineHeight: 1.5,
    textTransform: "uppercase" as const,
  },
  code: {
    fontFamily: "monospace",
    lineHeight: 1.5,
    fontSize: pxToRem(14),
    fontWeight: 500,
    backgroundColor: onDarkBase.color.neutral[800],
    padding: "0.2em 0.4em",
    borderRadius: "3px",
  },
};
